import { render } from "./SkillVue.vue?vue&type=template&id=2ff31cd4"
import script from "./SkillVue.vue?vue&type=script&lang=js"
export * from "./SkillVue.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hammer\\andolphi-curriculo-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__